import { useEffect, useState } from 'react';
import { getDrugsData } from '../../../api/admin';
import { exportPrescription, getAllConditions, getPrescription, getPrescriptions, postPrescription, putPrescription, recreatePrescriptionAPI } from '../../../api/medicalRecord';
import { HandleApiError } from '../../../components/Notifications/APIErrorHandler';

export const usePrescriptions = (medicalRecordNumber, entryId) => {

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        medicalRecordNumber: medicalRecordNumber ? medicalRecordNumber : 0,
        entryId: entryId ? entryId : 0,
        pagination: {
            page: 1,
            sizePerPage: 10,
            totalSize: 0
        }
    });
    const [reload, setReload] = useState(false);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                setReload(false);
                setIsLoading(true);
                const paginatedItems = await getPrescriptions(query);
                if (isSubscribed) {
                    setTotalSize(paginatedItems.data.count);
                    setData(paginatedItems.data.data);
                    setIsLoading(false);
                }
            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setTotalSize(0);
                setData([]);
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, [query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        var newQuery = JSON.parse(JSON.stringify(query));

        switch (type) {
            case 'pagination': {
                newQuery.pagination.page = page;
                newQuery.pagination.sizePerPage = sizePerPage;
                setQuery(newQuery);
                break;
            }
            case 'sort': {
                newQuery.sort.sortField = sortField;
                newQuery.sort.sortOrder = sortOrder;
                setQuery(newQuery);
                break;
            }
            default: break;
        }
    }

    return [data, query, totalSize, isLoading, handleTableChange, setReload];
}

export const usePrescription = (medicalRecordNumber, entryId, id) => {

    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);
    const [masterData, setMasterData] = useState(null);

    useEffect(() => {
        let isSubscribed = true
        const fetchData = async () => {
            try {
                const res = await getPrescription(entryId, id);
                if (isSubscribed) {
                    setData(res.data);
                    setIsLoading(false);
                }
            } catch (error) {
                HandleApiError(error);
                setIsLoading(false);
                setData(null);
            }
        }

        const getMasterData = async () => {
            var masterdata = {
                data: {
                    routesOfAdministration: [],
                    units: [],
                    frequencies: []
                },
                events: []
            };

            try {

                const res = await getDrugsData();
                masterdata.data = res.data;

                const query = {
                    medicalRecordNumber: medicalRecordNumber,
                    pagination: {
                        page: 1,
                        sizePerPage: 100,
                        totalSize: 0
                    },
                    filters: { actual: true }
                };
                var groups = [
                    {
                        label: 'Otros',
                        options: [{ id: 0, adverseEffect: "Profilaxis" }],
                    },
                    {
                        label: 'Patologías',
                        options: [],
                    }
                ];

                const paginatedItems = await getAllConditions(query);

                var resEvents = paginatedItems.data;
                resEvents.data.forEach(event => { event.reasonId = event.id; });
                groups[1].options = resEvents.data;
                masterdata.events = groups;
            }
            catch (error) {
                console.log(error)
            }

            setIsLoading(false);
            setMasterData(masterdata);
        }

        if (medicalRecordNumber)
            getMasterData();

        if (id)
            fetchData();

        return () => isSubscribed = false;
    }, [entryId, id, medicalRecordNumber]);

    const create = (entryId, data) => {
        return postPrescription(medicalRecordNumber, entryId, data);
    }

    const update = (entryId, id, data) => {
        return putPrescription(entryId, id, data);
    }

    const print = (medicalRecordNumber, entryId, id, pin) => {
        return exportPrescription(medicalRecordNumber, entryId, id, pin);
    }

    const recreate = (medicalRecordNumber, entryId, prescriptionId) => {
        return recreatePrescriptionAPI(medicalRecordNumber, entryId, prescriptionId);
    }

    return [data, masterData, isLoading, create, update, print, recreate];
}